/**
 * Entry point for Jacuzzi application
 *
 * Loads global polyfills
 * Loads the base stylesheet
 * Exposes a global `TBT` object for third-party interaction
 * Initializes analytics tools and feature flags
 * Bootstraps the React application
 */
import '@babel/polyfill'
import 'isomorphic-fetch'

import '../scss/master-styles.scss'

import './report'

import eventChannel from './eventChannel'
import features from './feature-flags'
import store from './store/store'

import {documentReady as analyticsDocumentReady} from './analytics'
import {documentReady as paneDocumentReady} from './pane'
import {documentReady as subscribeDocumentReady} from './store/subscribe'

window.TBT = window.TBT || {}
window.TBT = {
  ...window.TBT,
  eventChannel,
  features,
  store,
}

document.addEventListener('DOMContentLoaded', () => {
  subscribeDocumentReady()
  paneDocumentReady()
  analyticsDocumentReady()
  require('./root/Root') // eslint-disable-line global-require
})
